'use client';

import { Snackbar } from '@mui/material';

import { useWorkspace } from '@/contexts/useWorkspace';

export const InfoSnackbar = () => {
  const { snackbar } = useWorkspace();

  return (
    <Snackbar
      ContentProps={{
        sx: snackbar.isError
          ? {
              backgroundColor: 'var(--mui-palette-error-main)',
            }
          : snackbar.isWarning
            ? {
                backgroundColor: 'var(--mui-palette-warning-main)',
              }
            : {},
      }}
      sx={{
        marginLeft: '62px',
      }}
      open={snackbar.isOpen}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      autoHideDuration={snackbar.isWarning ? undefined : 3000}
      onClose={() => snackbar.hide()}
      message={snackbar.message}
    />
  );
};
